import * as React from "react";

import * as R from "ramda";

import {
  setNodeValueByUIDAndKey,
} from "../../src/doc_helpers";

import DocExtra from "./Extra";

import DocInlineText from "./InlineText";

import DocVideoJWPlayer from "./VideoJWPlayer";

import { performActions } from "../../src/doc_actions";

interface DocVideoProps extends VideoNode, EveryNodeArgs {
  imagingTypes?: Array<ImagingType>;
}

export default function DocVideo(props: DocVideoProps) {
  const {
    cover,
    currentDocument,
    currentUser,
    currentVersion,
    displayState,
    editState,
    extraTitle,
    imagingType,
    imagingTypes,
    onVideoComplete,
    source,
    title,
    uid,
    uri,
  } = props;

  if (!("aws_folder_url" in currentVersion) || !("media_assets" in currentDocument)) { return; }

  let editorButtons;
  if (editState.isEditor && editState.isEditing) {
    const onVideoEditClick = () => {
      const {
        editState,
        uid,
      } = props;

      if (editState.isEditor && editState.isEditing) {
        displayState.setOpenMenu({uid: uid, name: "MEDIA_MENU", mediaType: "video"});
      }
    };

    const handleImagingTypeChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
      currentVersion._actions.modifyEditJSON((json) =>
        setNodeValueByUIDAndKey(json, uid, "imagingType", e.target.value),
      );
    };

    editorButtons = (
      <>
        <span className="bg-sky-600 p-2 doc-media-edit-button" onClick={onVideoEditClick}><i className="fa fa-cog" /> Edit Video</span>
        {imagingTypes && R.length(imagingTypes) > 0 && (
        <select value={imagingType} onChange={handleImagingTypeChange} className="tag-select">
          <option value="">Select Imaging Type</option>
          {imagingTypes.map((t) => <option value={t} key={t}>{t}</option>)}
        </select>
      )}
      </>
    );
  }

  let video;
  switch (source) {
    case "local":
      const videoURL = `${currentVersion.aws_folder_url}/original/videos/${uri}`;

      video = (
        <video preload="none" controls>
          <source src={videoURL} />
        </video>
      );

      break;
    case "youtube":
      video = <iframe width="560" height="315" src={`https://www.youtube.com/embed/${uri}`} frameBorder="0" allowFullScreen />;

      break;
    case "vimeo":
      video = <iframe src={`https://player.vimeo.com/video/${uri}`} width="500" height="281" frameBorder="0" allowFullScreen />;

      break;
    case "reeldx":
      const mediaAsset = currentDocument.media_assets.find((media_asset) => media_asset.media_key === uri);

      let coverImageURL;
      if (cover) {
        coverImageURL = `${currentVersion.aws_folder_url}/compressed/images/${cover}`;
      }

      video = (
        <DocVideoJWPlayer
          key={uri}
          videoURL={`https://d3o9veyy7wy4ai.cloudfront.net/${uri}`}
          coverImageURL={coverImageURL}
          hasCaptions={!!mediaAsset?.three_play_media_captions_processed_at || !mediaAsset} // TEMP: !mediaAsset enables captions even if file is not attached
          shouldLoop={!!mediaAsset?.is_silent}
          onVideoPlayEvent={(time) => currentUser.logEvent(uid, "video_played", time)}
          onVideoCompleteEvent={() => onVideoComplete && performActions(onVideoComplete, currentUser)}
          subtitlesByLanguage={mediaAsset?.subtitle_file_by_language || {}}
        />
      );

      break;
    default:
      return (
        <DocExtra
          subtype="error"
          content={`Unknown video source type: ${source}`}
          editState={editState}
        />
      );
  }

  return (
    <div className={`doc-video doc-video-${source}`}>
      <div className="doc-video-wrapper">
        {video}
        {editorButtons}
      </div>
      <figcaption>
        <DocInlineText content={title} uid={uid} contentKey="title" editState={editState}/>
      </figcaption>
      <figcaption>
        {extraTitle}
      </figcaption>
    </div>
  );

}
